import React from 'react'
import { Button } from '../ui/button'
import { ArrowLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

const BackBtn: React.FC = () => {
    const navigate = useNavigate();
    return (
        <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-muted-foreground hover:text-foreground border border-border rounded-full p-2 w-9 h-9 lg:w-10 lg:h-10 justify-center group bg-white"
        >
            <ArrowLeft className="w-4 h-4 group-hover:text-black" />
        </Button>
    )
}

export default BackBtn